import { render, staticRenderFns } from "./ControleAgendamento.vue?vue&type=template&id=52bc6f00&scoped=true"
import script from "./ControleAgendamento.vue?vue&type=script&lang=js"
export * from "./ControleAgendamento.vue?vue&type=script&lang=js"
import style0 from "./ControleAgendamento.vue?vue&type=style&index=0&id=52bc6f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bc6f00",
  null
  
)

export default component.exports